/* eslint-disable */

import React from "react";
import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "../../datatablesource";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Box } from "@material-ui/core";
import Tooltip from '@mui/material/Tooltip';
import LocalHospitalOutlinedIcon from '@mui/icons-material/LocalHospitalOutlined';
import HotelIcon from '@mui/icons-material/Hotel';
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import usePatientHook from "../patient-timeline/patientHook/patientHook";

const Datatable = (props) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const { patientList, handleClick, handlePathologyClick,
    handlePagination, page, pageSize, handleIpdClick,  } = props

    const { handlePdfClick } = usePatientHook()
  const handleDelete = (id) => {
    setData(data.filter((item) => item?.uniqueID !== id));
  };

  const handleGetRowId = (e) => {
    return e?.uniqueID
  }
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <div className="viewButton" onClick={() => handleClick(params.row)}>
              <Tooltip title="Add Opd">
                <LocalHospitalOutlinedIcon
                  style={{ color: "green"}}
                  onClick={() => handleClick(params.row)} />
              </Tooltip>

            </div>
            <div className="viewButton" >
              <Tooltip title="Add IPD">
                <HotelIcon style={{ color: "green"}} onClick={() => handleIpdClick(params.row)}
                />
              </Tooltip>
            </div>
            <div className="viewButton" >
              <Tooltip title="Add Pathology">
                <BiotechOutlinedIcon style={{ color: "green"}} onClick={() => handlePathologyClick(params.row)} />
              </Tooltip>
            </div>
            <div className="viewButton" >
              <Tooltip title="Add Pathology">
                <PictureAsPdfIcon style={{ color: "green"}} onClick={() => handlePdfClick(params.row)} />
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];
  const handleOnCellClick = (params) => {
    if (params?.field === "emrNumber") {
      params && params?.field?.length > 0 ?
        navigate("/patient-registration/basic-information", { state: { addPatient: false, rowData: params?.row } }) : null
    }

  };

  return (
    <Box className="datatable" sx={{ height: 520, width: '100%' }}>
      <DataGrid
        checkboxSelection={false}
        className="datagrid"
        rows={patientList && patientList !== null ? patientList : []}
        columns={[...actionColumn, ...userColumns]}
        rowsPerPageOptions={[10]}
        getRowId={handleGetRowId}
        loading={patientList?.length > 0 || patientList === null ? false : false}
        disableSelectionOnClick
        experimentalFeatures={{ newEditingApi: true }}
        onCellClick={handleOnCellClick}
        onPageChange={(newPageSize) => handlePagination(newPageSize)}
        initialState={patientList}
        pagination
        pageSize={pageSize}
        disableColumnMenu={true}
      />
    </Box>
  );
};

export default Datatable;
